/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AgentGamingListOperation = "ADD" | "REMOVE" | "%future added value";
export type ModifyAgentGamingUserWhitelistMutationVariables = {
    mobile: string;
    operation: AgentGamingListOperation;
    comment?: string | null | undefined;
};
export type ModifyAgentGamingUserWhitelistMutationResponse = {
    readonly modifyAgentGamingUserWhitelist: {
        readonly success: boolean;
    } | null;
};
export type ModifyAgentGamingUserWhitelistMutation = {
    readonly response: ModifyAgentGamingUserWhitelistMutationResponse;
    readonly variables: ModifyAgentGamingUserWhitelistMutationVariables;
};



/*
mutation ModifyAgentGamingUserWhitelistMutation(
  $mobile: String!
  $operation: AgentGamingListOperation!
  $comment: String
) {
  modifyAgentGamingUserWhitelist(mobile: $mobile, operation: $operation, comment: $comment) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comment"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operation"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "comment",
        "variableName": "comment"
      },
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      },
      {
        "kind": "Variable",
        "name": "operation",
        "variableName": "operation"
      }
    ],
    "concreteType": "ModifyAgentGamingUserWhitelist",
    "kind": "LinkedField",
    "name": "modifyAgentGamingUserWhitelist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifyAgentGamingUserWhitelistMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ModifyAgentGamingUserWhitelistMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d0459a39c1a38bbba5334920135f90ee",
    "id": null,
    "metadata": {},
    "name": "ModifyAgentGamingUserWhitelistMutation",
    "operationKind": "mutation",
    "text": "mutation ModifyAgentGamingUserWhitelistMutation(\n  $mobile: String!\n  $operation: AgentGamingListOperation!\n  $comment: String\n) {\n  modifyAgentGamingUserWhitelist(mobile: $mobile, operation: $operation, comment: $comment) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '8ff355516def257ebbdbc8ea5abd800e';
export default node;
